import { fromJS } from 'immutable';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { composeModules } from 'holocron';

export const LOADING = 'modules/axp-benefits-view-all/LOADING';
export const LOADED = 'modules/axp-benefits-view-all/LOADED';
export const LOAD_FAILED = 'modules/axp-benefits-view-all/LOAD_FAILED';

const initialState = fromJS({
  isLoading: false,
  isLoaded: false,
  error: null,
});

// eslint-disable-next-line default-param-last -- needed
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOADING: {
      return state.merge({ isLoading: true, isLoaded: false });
    }

    case LOADED: {
      return state.merge({ isLoading: false, isLoaded: true });
    }

    case LOAD_FAILED: {
      return state.merge({ isLoading: false, isLoaded: false, error: action.error });
    }

    default:
      return fromJS(state);
  }
}

export const loadModuleData = ({ store: { dispatch } }) => {
  dispatch({ type: LOADING });
  return Promise.all([
    dispatch(loadLanguagePack('axp-benefits-view-all'), { fallbackLocale: 'en-US' }),
    dispatch(composeModules([
      { name: 'axp-global-rewards-nav' },
      { name: 'axp-benefits-trackers' },
    ])),
  ])
    .then(() => dispatch({ type: LOADED }))
    .catch((error) => dispatch({ type: LOAD_FAILED, error }));
};
